var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-4 pt-4"},[_c('p',{staticClass:"home-section-title"},[_vm._v("Support")]),_c('p',[_vm._v(" Fill out the support form below and we will get back to you within 1 business day. ")]),_c('ContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }